<div class="app-component-container">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <div class="content faq-section">
        <div class="faq-container">
            <mat-accordion multi="false" class="faq-accordion">
                @for (elemIds of groupElementSignals['faq-items'](); let index = $index; track $index) {
                    <app-base-faq-item [elementIds]="elemIds"></app-base-faq-item>
                }
            </mat-accordion>
        </div>
    </div>
</div>
